<template>
  <div class="my-16">
    <div class="max-w-2xl mx-auto ">
      <h3 class="text-center text-base text-gray-700 sm:text-lg md:mt-5 md:text-xl">
        We are building a service to easily create beautiful personalized
        images. Customers become friends with personalisation.
      </h3>
      <!-- <img
        class="mx-auto h-16 my-4"
        src="../../assets/arrow.png"
      /> -->
    </div>

    <div
      class="flex flex-row justify-evenly  my-10 flex-wrap"
      style="background:#5a5a7d"
    >
      <!-- <img
        class="object-contain  sm:my-10 cursor-pointer"
        src="../../assets/template.png"
        @click="openImageInNewTab"
      /> -->
    </div>
    <div class="bg-white  shadow-lg  sm:rounded-lg max-w-3xl mx-auto ">
      <div class="px-4 py-5 sm:p-6">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Subscribe
        </h3>
        <div class="mt-2 max-w-xl text-sm leading-5 text-gray-500">
          <p>
            Be the first to know when we launch
          </p>
        </div>
        <form @submit="handleSubmit">
          <div class="mt-5 sm:flex sm:items-center">
            <div
              class="max-w-xs w-full"
              v-if="!isSubscribed"
            >
              <label
                for="email"
                class="sr-only"
              >Email </label>
              <div class="relative rounded-md shadow-sm">
                <input
                  id="email"
                  type="email"
                  class="form-input block w-full sm:text-sm sm:leading-5"
                  placeholder="you@example.com"
                  v-model="email"
                />
              </div>
            </div>
            <div
              class="mt-2 max-w-xl text-sm leading-5 text-gray-500"
              v-if="isSubscribed"
            >
              <p>
                Subscribed :)
              </p>
            </div>
            <div
              class="mt-2 max-w-xl text-sm leading-5 text-gray-500"
              v-if="isErrorOnSubscription"
            >
              Error occurred while subscribing
            </div>
            <span
              class="mt-3 inline-flex rounded-md shadow-sm sm:mt-0 sm:ml-3 sm:w-auto"
              v-if="!isSubscribed"
            >
              <button
                type="submit"
                class="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150 sm:w-auto sm:text-sm sm:leading-5"
              >
                Let me know
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      isSubscribed: false,
      isErrorOnSubscription: false
    };
  },
  methods: {
    openImageInNewTab(event) {
      window.open(event.target.src, "_blank");
    },
    async handleSubmit(event) {
      event.preventDefault();

      try {
        fetch("https://supportexamples.com/api/user/getpersonal", {
          method: "POST", // or 'PUT'
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ email: this.email })
        });
        this.isSubscribed = true;
      } catch (error) {
        this.isErrorOnSubscription = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
